/** 헤더 배지·로고 태그 다국어 필드 선택 */

export function isAppLanguageEnglish(lang) {
  return String(lang || 'ko').toLowerCase().startsWith('en');
}

/** 배지: text(한글) · textEn(영문) */
export function resolveHeaderBadgeText(badge, lang) {
  if (!badge) return '';
  const useEn = isAppLanguageEnglish(lang);
  if (useEn && badge.textEn) return badge.textEn;
  return badge.text || badge.textEn || '';
}

/**
 * 로고 태그 title/subtitle — { kor, eng } 객체 또는 legacy titleEn
 * @returns {{ title: string, subtitle: string }}
 */
export function resolveHeaderLogoTagText(tag, lang) {
  if (!tag) return { title: '', subtitle: '' };
  const useEn = isAppLanguageEnglish(lang);

  const pick = (field, legacyEnKey) => {
    const v = tag[field];
    if (v && typeof v === 'object') {
      return useEn ? (v.eng ?? v.kor ?? '') : (v.kor ?? v.eng ?? '');
    }
    if (useEn && tag[legacyEnKey]) return tag[legacyEnKey];
    return v || tag[legacyEnKey] || '';
  };

  return {
    title: pick('title', 'titleEn'),
    subtitle: pick('subtitle', 'subtitleEn'),
  };
}
